<template>
	<!-- 报名信息-立即报名 -->
	<div>
		<!-- v-show="$route.meta.showFather" -->
		<div class="" style="color: #000000;" v-show="$route.meta.showFather">
			<div class="pad-16 mb-16 box-shadow" style="color: #000000;margin-top: 16px;">
				<div class="is-flex mb-16">
					<div class="left-icon"></div>
					<p class="left-p">精彩活动</p>
				</div>
				<div class="is-flex jus-bet">
					<div>
						<div class="is-flex mb-16">
							<p class="left-p " style="padding-left: 0;padding-right: 16px;">{{detail.name}}</p>
							<p v-if="infoShow" class="act-status"
								:class="detail.activityStatus==1000?'act-status-1':detail.activityStatus==2000?'act-status-2':'act-status-3'">
								{{detail.activityStatus==1000?'待开始':detail.activityStatus==2000?'进行中':'已结束'}}
							</p>
						</div>
						<div class="is-flex">
							<div class="is-flex" style="margin-right: 3.6875rem;">
								<p class="name-2">活动时间:</p>
								<p class="name-3">
									{{utils.getNowTime(detail.startTime)}}-{{utils.getNowTime(detail.endTime)}}
								</p>
							</div>
							<div class="is-flex">
								<p class="name-2">活动地点:</p>
								<p class="name-3">{{detail.location}}</p>
							</div>
						</div>
					</div>
					<p class="money-1" v-if="infoShow">¥&nbsp;{{detail.price}}</p>
				</div>
			</div>
			<div class="pad-16 mb-16 box-shadow">
				<div class="is-flex mb-24">
					<div class="left-icon"></div>
					<p class="left-p">基本信息</p>
				</div>
				<el-form ref="form" :rules="rules" :model="form" class="boc-form" label-width="80px">
					<el-form-item label="单位名称" prop="companyName">
						<el-input v-model="form.companyName" placeholder="请输入单位名称" :disabled="disabled"></el-input>
					</el-form-item>
					<el-form-item label="姓名" prop="name">
						<el-input v-model="form.name" placeholder="请输入您的姓名" :disabled="disabled"></el-input>
					</el-form-item>
					<el-form-item label="职位" prop="position">
						<el-input v-model="form.position" placeholder="请输入您的职位" :disabled="disabled"></el-input>
					</el-form-item>
					<el-form-item label="手机号码" prop="contact">
						<el-input v-model="form.contact" placeholder="请输入您的手机号码" :disabled="disabled"></el-input>
					</el-form-item>
					<el-form-item label="邮箱" prop="email">
						<el-input v-model="form.email" placeholder="请输入您的邮箱" :disabled="disabled"></el-input>
					</el-form-item>
					<el-form-item label="地址" prop="address">
						<el-input v-model="form.address" placeholder="请输入您的详细地址:省市区、具体街道" :disabled="disabled">
						</el-input>
					</el-form-item>
				</el-form>
				<p class="tishi-1" v-if="infoShow">我们会保护您的基本信息，请您放心填写</p>
			</div>
			<div class="pad-16 mb-16 box-shadow" v-if="infoShow">
				<div class="is-flex mb-24">
					<div class="left-icon"></div>
					<p class="left-p">支付方式</p>
				</div>
				<div class="is-flex jus-bet mb-24" style="align-items: flex-end;">
					<img src="../../assets/head/wxzhifu.png" alt="" class="wxzf">
					<div class="is-flex apply">
						<p>总计:</p>
						<p>¥&nbsp;{{detail.price}}</p>
					</div>
				</div>
				<div class="is-flex jus-bet">
					<div></div>
					<el-button type="primary" @click="apply">立即购买</el-button>
				</div>
			</div>
			<div class="pad-16 mb-24 box-shadow" v-if="!infoShow">
				<div class="is-flex mb-24">
					<div class="left-icon"></div>
					<p class="left-p">订单信息</p>
				</div>
				<div class="is-flex jus-bet">
					<div class="is-flex">
						<p class="name-2">支付金额:</p>
						<p class="name-3">¥&nbsp;{{detail.price}}</p>
					</div>
					<div class="is-flex">
						<p class="name-2">支付时间:</p>
						<p class="name-3">{{utils.getNowTime(form.createTime)}}</p>
					</div>
					<div class="is-flex">
						<p class="name-2">订单编号:</p>
						<p class="name-3">{{form.no}}</p>
					</div>
					<div></div>
				</div>
			</div>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	import headView from '@/views/headView.vue';
	import footers from '@/views/footers.vue';
	import Breadcrumb from '@/views/Breadcrumb.vue';
	import {
		getRegistration,
		getCreate,
		getActivityDetail,
		orderSubmit,
		getPayment
	} from '@/api/activity/api.js';
	export default {
		components: {
			headView,
			footers,
			Breadcrumb
		},
		data() {
			// 自定义验证邮箱
			var checkEmail = (rule, value, callback) => {
				if (value === "") return callback();
				const regEmail = /^([a-zA-Z0-9])+@([a-zA-Z0-9_-])+([a-zA-Z0-9_-])+/;
				if (regEmail.test(value)) {
					return callback();
				} else {
					callback(new Error("请输入合法邮箱"));
				}
			};
			// 自定义验证手机号
			var checkPhone = (rule, value, callback) => {
				const phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
				if (value.trim() !== "") {
					if (phoneReg.test(value)) {
						callback();
					} else {
						callback(new Error("请输入合法手机号"));
					}
				} else {
					callback();
				}
			};
			return {
				infoShow: false,
				disabled: false,
				form: {
					companyName: '',
					position: '',
					contact: '',
					email: '',
					address: '',
					name: '',
					resource: '',
					tyle: '',
					eventId: ''
				},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					companyName: [{
						required: true,
						message: '请输入单位名称',
						trigger: 'blur'
					}],
					position: [{
						required: true,
						message: '请输入职位',
						trigger: 'blur'
					}, ],
					contact: [{
						required: true,
						message: '请输入正确的手机号码',
						trigger: 'blur',
						type: "number",
						validator: checkPhone,
					}],
					email: [{
						required: true,
						message: '请输入正确的邮箱',
						trigger: 'blur',
						validator: checkEmail,
					}],
					// address: [{
					//     required: true,
					//     message: '请输入地址',
					//     trigger: 'blur',

					// }],


				},
				orderId: '',
				payId: '',
				num: '',
				detail: ''
			}
		},
		created() {

		},
		mounted() {
			this.form.eventId = this.$route.params.id;
			this.num = this.$route.params.num;
			console.log(this.num, 'this')
			if (this.num == 1) {
				this.disabled = true;
				this.infoShow = false;
			} else {
				this.disabled = false;
				this.infoShow = true;
			}
			// if (this.form.eventId !== undefined) {
			//     this.getDeatils(this.form.eventId);
			//     localStorage.setItem('ids', this.form.eventId)
			// } else {
			//     this.form.eventId = localStorage.getItem('ids');
			//     this.getDeatils(this.form.eventId);
			// }

			this.getDeatils(this.$route.params.id);
			this.getRegData(this.$route.params.id);

		},
		methods: {
			getDeatils(id) {
				getActivityDetail({
						id: id
					}).then(res => {
						console.log(res.data, '--')
						this.detail = res.data;
					})
					.catch(error => {

					});
			},
			getRegData(id) {
				getRegistration({
						id: id
					}).then(res => {
						if(res.data){
							this.form = res.data;
						}
					})
					.catch(error => {

					});
			},
			// getInfo(id) {
			//     getRegistration({
			//             id: id
			//         }).then(res => {
			//             console.log(res.data, '--')
			//             this.form = res.data;
			//         })
			//         .catch(error => {

			//         });
			// },
			// 报名信息
			// info() {
			//     this.$router.push('/activity/information')
			// },
			// quily() {
			//     this.$router.push('/activity/information')
			// },
			apply() {
				let params = this.form;
				getCreate(params).then(res => {
						console.log(res.data, '--')
						this.orderId = res.data;
						this.submitOrder()
					})
					.catch(error => {

					});
				// this.$router.push('/activity/payment')
			},
			submitOrder() {
				getPayment({
						orderId: this.orderId,
						type: 2
					}).then(res => {
						// console.log(res.data, '--')
						this.payId = res.data
						this.orderPay(this.payId);
					})
					.catch(error => {

					});
			},
			orderPay(id) {
				let params = {
					id: id,
					channelCode: 'wx_native',
					// returnUrl:'https://www.zgjyzjw.com/activity/paymentSuccess?id='+this.form.eventId
				}
				orderSubmit(params).then(res => {
						this.displayContent = res.data.displayContent; // 要生成二维码
						console.log(res.data, '--111')
						// 跳转支付页面生成二维码
						this.$router.push({
							name: '/activity/payment',
							params: {
								id: this.form.eventId,
								displayContent: this.displayContent,
								price: this.detail.price
							}
						})

					})
					.catch(error => {

					});
			}

		}
	}
</script>


<style scoped>
	.pad-16 {
		padding: 16px;

	}

	.box-shadow {
		box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.is-flex {
		display: flex;
		align-items: center;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.hed-img {
		/*   width: 100%;
       height: auto; */
		width: 576px;
		height: 320px;
		padding-right: 32px;
	}

	.name-1 {
		font-size: 20px;
		padding-right: 9px;
	}

	.name-2 {
		color: #999999;
		font-size: 14px;
		white-space: nowrap;
		padding-right: 8px;
	}

	.name-3 {
		color: #222222;
		font-size: 14px;
		font-weight: normal;
	}


	.mb-8 {
		margin-bottom: 8px;
	}

	.mb-24 {
		margin-bottom: 24px;
	}

	.flex-tab {
		border-radius: 8px;
	}

	.flex-tab p {
		width: 25%;
		color: #666666;
		font-size: 14px;
		text-align: center;
		padding: 16px 0;
		background: #FAFAFA;
	}

	.flex-tab p:first-child {
		background: #3377FF;
		color: #FFFFFF;
	}

	.mb-16 {
		margin-bottom: 16px;
	}

	.left-icon {
		width: 6px;
		height: 20px;
		background: #3377FF;
		border-radius: 18px;
	}

	.left-p {
		font-size: 20px;
		color: #222222;
		font-weight: normal;
		padding-left: 10px;
	}

	.align-base {
		align-items: flex-start;
	}

	.baoming {
		width: 20%;
		min-width: 20%;
		text-align: center;
		padding: 12px 24px;
		background: #3377FF;
		border-radius: 8px 8px 8px 8px;
		font-size: 14px;
		font-weight: normal;
		color: #FFFFFF;
		white-space: nowrap;
	}

	.money-1 {
		color: #FF5533;
		font-weight: normal;
		line-height: 33px;
		font-size: 28px;
	}

	.boc-form {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.boc-form .el-form-item {
		width: 40%;
		margin-bottom: 1.125rem;
	}

	/deep/.boc-form .el-form-item__label {
		padding-right: 16px;
		color: #222222;
		font-size: 14px;
	}

	/deep/.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
		margin-right: 0;
	}

	.tishi-1 {
		color: #CCCCCC;
		font-size: 14px;
		margin-top: 12px;
	}

	.wxzf {
		width: 5.5rem;
		height: 5.5rem;
	}

	.apply p:first-child {
		color: #222222;
		font-size: 14px;
		margin-right: 1rem;
	}

	.apply p:last-child {
		color: #FF5533;
		font-size: 28px;
	}

	/deep/.el-button--primary {
		background-color: #3377FF;
		border-radius: 4px;
	}

	/deep/.el-button--primary span {
		font-size: 16px;
		color: #ffffff;
		/* padding: 0.75rem 0; */
		text-align: center;
	}

	.act-status {
		border-radius: 4px 16px 4px 16px;
		padding: 4px 16px;
		font-size: 14px;
		white-space: nowrap;
	}

	.act-status-1 {
		color: #FBB54C;
		background: #FFF6F0;
	}

	.act-status-2 {
		color: #3ECC64;
		background: #EBFAEF;
	}

	.act-status-3 {
		color: #FF534D;
		background: #FFF0F0;
	}

	/deep/.el-input.is-disabled .el-input__inner {
		background-color: #EFEFEF;
		color: #222222;
		font-size: 14px;

	}
</style>